export default __webpack_public_path__ + "static/media/jamie_t.2099bc89.jpg";